(ns practitest.frontend.components.run-status
  (:require [reagent.core :as reagent]
            ["react-select" :default Select :refer [components]]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.lists :as lists]
            [practitest.frontend.common.i18n :refer [get-translation]]))

;; TODO: from backend ?
(def statuses-map
  {"PENDING"       {:label (get-translation "run-status.pending" "Pending")
                    :icon  icons/three-dots
                    :color "var(--pt-color-status-pending)"
                    :class "status-pending"}
   "RUNNING"       {:label (get-translation "run-status.running" "Running")
                    :color "var(--pt-color-status-running)"
                    :class "status-running"
                    :icon  icons/icons-spinner}
   "PASSED"        {:label (get-translation "run-status.passed" "Passed")
                    :color "var(--pt-color-success)"
                    :class "status-passed"
                    :icon  icons/check-circle-fill}
   "FAILED"        {:label (get-translation "run-status.failed" "Failed")
                    :color "var(--pt-color-error)"
                    :class "status-failed"
                    :icon  icons/x-circle-fill}
   "CANCELED"      {:label (get-translation "run-status.canceled" "Canceled")
                    :class "status-canceled"
                    :icon  icons/slash-circle
                    :color "var(--pt-color-status-canceled)"}
   "ERROR"         {:label (get-translation "run-status.error" "Error")
                    :class "status-error"
                    :color "var(--pt-color-error)"
                    :icon  icons/exclamation-circle-fill}
   "NO RUN"        {:label (get-translation "run-status.no-run" "No Run")
                    :icon  icons/file-earmark
                    :color "var(--pt-color-status-no-run)"}
   "BLOCKED"       {:label (get-translation "run-status.blocked" "Blocked")
                    :color "var(--pt-color-status-blocked)"
                    :icon  icons/dash-circle}
   "NOT COMPLETED" {:label (get-translation "run-status.not-completed" "Not Completed")
                    :color "var(--pt-color-status-not-completed)"
                    :icon  icons/file-earmark-medical}
   "N/A"           {:label (get-translation "run-status.na" "N/A")
                    :color "var(--pt-color-status-na)"
                    :icon  icons/not-applicable}})

(defn get-status-label
  [status]
  (when status
    (or (:label (get statuses-map status))
        (str "UNMAPPED STATUS " status))))

(defn get-status-icon
  [status]
  (when-let [icon (:icon (get statuses-map status))]
    [icon]))

(defn get-status-class
  [status]
  (:class (get statuses-map status)))

(defn get-status-color
  [status]
  (:color (get statuses-map status)))

(defn status-label
  [status]
  [:span.status
   ;; Support class/color styling
   (let [class (get-status-class status)]
     (if class
       {:class (get-status-class status)}
       {:style {:color (get-status-color status)}}))
   [:span.me-1 (get-status-icon status)]
   (get-status-label status)])
